import doc                                  from '@widesk-core/decorators/doc';
import AbstractStonecodeMailEditorMailModel from './AbstractStonecodeMailEditorMailModel';
import { Translatable }                     from '@widesk-core/decorators/translatable';

@doc.urnResource('stonecode_mail_editor_mail')
@doc.translatable({ subject: true, content: true, description: true })
class StonecodeMailEditorMailModel extends AbstractStonecodeMailEditorMailModel {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	// Override the path to show "mails" only in URL (not stonecode_mail_editor_mail)
	public get pagePath(): string {
		return this.pagePathPrefix + `/mails/${this.id}`;
	}
}

interface StonecodeMailEditorMailModel
	extends Translatable<{ subject: true; content: true; description: true }> {
}

export default StonecodeMailEditorMailModel;